import {json, texture, Vector2} from "p3";
import { Emitter } from "pixi-particles";
import common from "../../../common";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";
import Entity from "../../Entity";
import ItemTreasure from "../item/ItemTreasure";

export default class HiddenTreasureSpot extends Entity {
    constructor(decal) {
        super();

        this._decal = decal;
        this._radius = 120;
        this._vector = null;
    }

    init() {
        super.init();

        /*
        const graphic = new PIXI.Graphics();
        graphic.lineStyle(2, 0x000000);
        graphic.drawCircle(0, 0, this._radius);
        this.addChild(graphic);
        */

        this._decal.emitFx([texture("path_tile_sparkle_attract_fx_00"), texture("path_tile_sparkle_attract_fx_01")], "fx_treasure_chest_attract");

        this._vector = new Vector2(0, 0);
    }

    update() {

        this._vector.set(GameScene.active.player.x - this.x, GameScene.active.player.y - this.y - (this._decal.height/2));
        if (this._vector.length < this._radius) {
            GameScene.active.addTween(
                gsap.to(this._decal, 0.5, {alpha:0, onComplete:() => {
                    const treasure = new ItemTreasure();
                    treasure.position.set(this.x, this.y);
                    GameScene.active.world.addEntity(treasure);
                    treasure.spawn();
                    treasure.collect();
                    if(common.saveData.activeSlot.treasures.indexOf(GameScene.active.loadedLevel + '_' + this._decal.gid) < 0) {
                        common.saveData.activeSlot.treasures.push(GameScene.active.loadedLevel + '_' + this._decal.gid);
                        common.saveData.saveGame();
                    }
                    GameScene.active.hud.compass.reset(GameScene.active.world.getHiddenTreasure());

                    if (GameScene.active.progressQuestManually("hidden_treasure", "badger", 1) ) {
                        GameScene.active.completeQuestManually("hidden_treasure", "badger");
                    }

                    let interaction = "compass treasure chest found";
                    common.tracking.trackEvent(definitions.TRACKING.EVENT_TYPE.INTERACTION, {
                        section: common.tracking.getSection(),
                        contenttitle: interaction,
                        interaction: interaction,
                        progress: common.tracking.progress,
                        interactionevent: 1
                    });

                    /*
                    const npc = "badger";
                    const quest = "hidden_treasure";
                    const data = json(badger);
                    */

                    /*
                    if(quest && common.saveData.activeSlot.acorns.length >= data.quests[quest].metadata.target) {
                        GameScene.active.completeQuestManually(quest, 'badger');
                        const coins = new CoinAnimation(data.quests[quest].metadata.coinReward, GameScene.active);
                        coins.x = this.x;
                        coins.y = this.y;
                        this.parent.addChild(coins);
                        common.saveData.activeSlot.coins += data.quests[quest].metadata.coinReward;
                        common.saveData.saveGame();
                        GameScene.active.inventory.addItem(definitions.ITEM_ID.ACORN, data.quests[quest].metadata.target);

                        GameScene.active.hud.coinHolder.coinAmount = common.saveData.activeSlot.coins;

                        return false;
                    }*/

                }})
            )
            GameScene.active.world.removeEntity(this);
        }

        super.update();
    }

    destroy() {
        if (this._fx) {
            this._fx.destroy();
            this._fx = null;
        }
        super.destroy();
    }

    getTreasureCount() {
        for(let i in common.saveData.activeSlot.treasures) {

        }
    }

    get isHiddenTreasureSpot() {
        return true;
    }

    get vector() {
        return this._vector;
    }

}